export default "__VITE_ASSET__Cnlwcl8E__"